import { useCallback, useRef, useState } from 'preact/hooks';
import { useResizeObserver } from '../hooks/UNSAFE_useResizeObserver';
import { BaseCardView, gutterSizeToPX, getColCount } from '../PRIVATE_BaseCardView';
import { BaseCardViewPublicProps as Props } from './BaseCardView.types';

type CardFlexViewProps<K extends string | number, D> = Props<K, D>;
type SizeInfo = {
  cardWidth?: number;
  cardHeight?: number;
  containerWidth?: number;
};

export function CardFlexView<K extends string | number, D>(props: CardFlexViewProps<K, D>) {
  const rootRef = useRef<HTMLDivElement>(null);

  const [size, setSize] = useState<SizeInfo>({});
  const updateCardSize = useCallback((cardWidth: number, cardHeight: number) => {
    setSize((size) => ({ ...size, cardWidth, cardHeight }));
  }, []);

  const handleResize = useCallback(
    (entry: ResizeObserverEntry) => {
      const containerWidth = entry.contentRect.width;
      if (size.containerWidth !== containerWidth) {
        setSize((size) => ({ ...size, containerWidth }));
      }
    },
    [size]
  );
  useResizeObserver(rootRef, handleResize);

  const gutterSizePX = gutterSizeToPX[props.gutterSize || 'sm'];
  const columns = getColCount(gutterSizePX, size.cardWidth, size.containerWidth);
  const cardSize = { width: size.cardWidth, height: size.cardHeight };

  return (
    <BaseCardView
      {...props}
      ref={rootRef}
      layout="flex"
      columns={columns}
      cardSize={cardSize}
      updateCardSize={updateCardSize}
    />
  );
}
